import * as React from 'react';
import {
  Navigate,
  Outlet,
  ScrollRestoration,
  useSearchParams,
} from 'react-router-dom';
import { useAuthStore } from '../../store';
import PageLoadTracker from '../../components/page-load-tracker/page-load-tracker';

const RedirectNavigator = () => {
  const { isAuthenticated } = useAuthStore();
  const [searchParams] = useSearchParams();

  const redirect = searchParams.get('redirect');
  // Route authenticated users to the redirect query param maintaining other query params
  if (isAuthenticated && redirect) {
    searchParams.delete('redirect');
    return <Navigate to={{ pathname: redirect, search: searchParams.toString() }} replace />;
  }
  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <PageLoadTracker />
      <Outlet />
    </>
  );
};

export default RedirectNavigator;
